export const mapMilestoneFromApi = (apiData) => {
  if (!apiData) return {};

  return {
    exportMilestoneCustomerRemark:
      apiData.exportMilestoneCustomerRemark || "",

    sbFiled: apiData.sbFiled
      ? {
          name: apiData.sbFiled.name || "",
          planDate: apiData.sbFiled.planDate || "",
          actualDate: apiData.sbFiled.actualDate || "",
          remarks: apiData.sbFiled.remarks || "",
          handledBy: apiData.sbFiled.handledBy || "",
          SBNo: apiData.sbFiled.SBNo || "",
          SBDate: apiData.sbFiled.SBDate || "",
          filePath: apiData.sbFiled.filePath || null,
        }
      : null,

    sbReceipt: apiData.sbReceipt
      ? {
          name: apiData.sbReceipt.name || "",
          planDate: apiData.sbReceipt.planDate || "",
          actualDate: apiData.sbReceipt.actualDate || "",
          remarks: apiData.sbReceipt.remarks || "",
          handledBy: apiData.sbReceipt.handledBy || "",
          filePath: apiData.sbReceipt.filePath || null,
        }
      : null,

    assessed: apiData.assessed
      ? {
          name: apiData.assessed.name || "",
          planDate: apiData.assessed.planDate || "",
          actualDate: apiData.assessed.actualDate || "",
          remarks: apiData.assessed.remarks || "",
          handledBy: apiData.assessed.handledBy || "",
        }
      : null,

    carted: apiData.carted
      ? {
          name: apiData.carted.name || "",
          planDate: apiData.carted.planDate || "",
          actualDate: apiData.carted.actualDate || "",
          remarks: apiData.carted.remarks || "",
          handledBy: apiData.carted.handledBy || "",
        }
      : null,

    examined: apiData.examined
      ? {
          name: apiData.examined.name || "",
          planDate: apiData.examined.planDate || "",
          actualDate: apiData.examined.actualDate || "",
          remarks: apiData.examined.remarks || "",
          handledBy: apiData.examined.handledBy || "",
        }
      : null,

    leo: apiData.leo
      ? {
          name: apiData.leo.name || "",
          planDate: apiData.leo.planDate || "",
          actualDate: apiData.leo.actualDate || "",
          remarks: apiData.leo.remarks || "",
          handledBy: apiData.leo.handledBy || "",
        }
      : null,

    handOverCarrier: apiData.handOverCarrier
      ? {
          name: apiData.handOverCarrier.name || "",
          planDate: apiData.handOverCarrier.planDate || "",
          actualDate: apiData.handOverCarrier.actualDate || "",
          remarks: apiData.handOverCarrier.remarks || "",
          handledBy: apiData.handOverCarrier.handledBy || "",
        }
      : null,

    loaded: apiData.loaded
      ? {
          name: apiData.loaded.name || "",
          planDate: apiData.loaded.planDate || "",
          actualDate: apiData.loaded.actualDate || "",
          remarks: apiData.loaded.remarks || "",
          handledBy: apiData.loaded.handledBy || "",
        }
      : null,

    blRelease: apiData.blRelease
      ? {
          name: apiData.blRelease.name || "",
          planDate: apiData.blRelease.planDate || "",
          actualDate: apiData.blRelease.actualDate || "",
          remarks: apiData.blRelease.remarks || "",
          handledBy: apiData.blRelease.handledBy || "",
        }
      : null,

    epCopy: apiData.epCopy
      ? {
          name: apiData.epCopy.name || "",
          planDate: apiData.epCopy.planDate || "",
          actualDate: apiData.epCopy.actualDate || "",
          remarks: apiData.epCopy.remarks || "",
          handledBy: apiData.epCopy.handledBy || "",
        }
      : null,

    stuffing: apiData.stuffing
      ? {
          name: apiData.stuffing.name || "",
          planDate: apiData.stuffing.planDate || "",
          actualDate: apiData.stuffing.actualDate || "",
          remarks: apiData.stuffing.remarks || "",
          handledBy: apiData.stuffing.handledBy || "",
        }
      : null,
  };
};


export const mapMilestoneToApi = (formData) => {
  return {
    exportMilestoneCustomerRemark:
      formData.exportMilestoneCustomerRemark,

    sbFiled: formData.sbFiled && {
      name: formData.sbFiled.name,
      planDate: formData.sbFiled.planDate,
      actualDate: formData.sbFiled.actualDate,
      remarks: formData.sbFiled.remarks,
      handledBy: formData.sbFiled.handledBy,
      SBNo: formData.sbFiled.SBNo,
      SBDate: formData.sbFiled.SBDate,
      filePath: formData.sbFiled.filePath,
    },

    sbReceipt: formData.sbReceipt && {
      name: formData.sbReceipt.name,
      planDate: formData.sbReceipt.planDate,
      actualDate: formData.sbReceipt.actualDate,
      remarks: formData.sbReceipt.remarks,
      handledBy: formData.sbReceipt.handledBy,
      filePath: formData.sbReceipt.filePath,
    },

    assessed: formData.assessed && {
      name: formData.assessed.name,
      planDate: formData.assessed.planDate,
      actualDate: formData.assessed.actualDate,
      remarks: formData.assessed.remarks,
      handledBy: formData.assessed.handledBy,
    },

    carted: formData.carted && {
      name: formData.carted.name,
      planDate: formData.carted.planDate,
      actualDate: formData.carted.actualDate,
      remarks: formData.carted.remarks,
      handledBy: formData.carted.handledBy,
    },

    examined: formData.examined && {
      name: formData.examined.name,
      planDate: formData.examined.planDate,
      actualDate: formData.examined.actualDate,
      remarks: formData.examined.remarks,
      handledBy: formData.examined.handledBy,
    },

    leo: formData.leo && {
      name: formData.leo.name,
      planDate: formData.leo.planDate,
      actualDate: formData.leo.actualDate,
      remarks: formData.leo.remarks,
      handledBy: formData.leo.handledBy,
    },

    handOverCarrier: formData.handOverCarrier && {
      name: formData.handOverCarrier.name,
      planDate: formData.handOverCarrier.planDate,
      actualDate: formData.handOverCarrier.actualDate,
      remarks: formData.handOverCarrier.remarks,
      handledBy: formData.handOverCarrier.handledBy,
    },

    loaded: formData.loaded && {
      name: formData.loaded.name,
      planDate: formData.loaded.planDate,
      actualDate: formData.loaded.actualDate,
      remarks: formData.loaded.remarks,
      handledBy: formData.loaded.handledBy,
    },

    blRelease: formData.blRelease && {
      name: formData.blRelease.name,
      planDate: formData.blRelease.planDate,
      actualDate: formData.blRelease.actualDate,
      remarks: formData.blRelease.remarks,
      handledBy: formData.blRelease.handledBy,
    },

    epCopy: formData.epCopy && {
      name: formData.epCopy.name,
      planDate: formData.epCopy.planDate,
      actualDate: formData.epCopy.actualDate,
      remarks: formData.epCopy.remarks,
      handledBy: formData.epCopy.handledBy,
    },

    stuffing: formData.stuffing && {
      name: formData.stuffing.name,
      planDate: formData.stuffing.planDate,
      actualDate: formData.stuffing.actualDate,
      remarks: formData.stuffing.remarks,
      handledBy: formData.stuffing.handledBy,
    },
  };
};
